import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

const request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
});

/**
 * Clase para manejar las llamadas a la API de Motivos de Diferencia
 */
export default class MotivosRequest {
    /**
     * Obtener el listado de motivos de diferencia activos
     */
    static ListarMotivos() {
        return middleware.hasAuth(() => request.get('motivos'));
    }

    /**
     * Registrar un nuevo motivo de diferencia
     * @param {Object} data - { descripcion: string }
     */
    static GuardarMotivo(data) {
        return middleware.hasAuth(() => request.post('motivos', data));
    }

    /**
     * Actualizar la descripción de un motivo de diferencia
     * @param {number} id - ID del motivo
     * @param {Object} data - { descripcion: string }
     */
    static EditarMotivo(id, data) {
        return middleware.hasAuth(() => request.put(`motivos/${id}`, data));
    }

    /**
     * Realizar borrado lógico de un motivo de diferencia
     * @param {number} id - ID del motivo
     */
    static EliminarMotivo(id) {
        return middleware.hasAuth(() => request.delete(`motivos/${id}`));
    }
}
